"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagParentDoesNotExistError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when try to create a tag whose parent does not exist
 */
class TagParentDoesNotExistError extends client_library_1.ExtendableError {
    constructor() {
        super(`Tag parent does not exist`);
    }
}
exports.TagParentDoesNotExistError = TagParentDoesNotExistError;
//# sourceMappingURL=TagParentDoesNotExistError.js.map